import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { ToolTip, Icon } from "@lifepay/rc-ui-toolkit";
import hintSVG from "@lifepay/assets/sprites/feather/core/info.svg";
import codes from "data/mcc-codes.json";
import styles from "./HintedMCC.m.scss";

function HintedMCC(props) {
  const { theme, code } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      {code}
      {codes[code] && (
        <ToolTip type={"info"} dataTip={codes[code]}>
          <Icon
            sprite={hintSVG}
            size={"smallest"}
            theme={{
              wrapper: theme["icon-wrapper"],
            }}
          />
        </ToolTip>
      )}
    </div>
  );
}

HintedMCC.displayName = "HintedMCC";

HintedMCC.propTypes = {
  theme: PropTypes.object,
  code: PropTypes.string,
};

HintedMCC.defaultProps = {};
export default themr("@lifepay/HintedMCC", styles)(HintedMCC);



// WEBPACK FOOTER //
// ./src/components/utils/HintedMCC/HintedMCC.js